export default "__VITE_ASSET__BUYs0CqQ__"